import React, { useRef, useEffect, useState } from "react";

const AnswerModal = ({ content, visible, position }) => {
  const ref = useRef();
  const [offsetTop, setOffsetTop] = useState(0);

  useEffect(() => {
    if (ref.current) {
      const height = ref.current.offsetHeight || 0;
      setOffsetTop(height); // we’ll subtract this from the position.top
    }
  }, [content, position]);

  if (!visible) return null;

  return (
    <div
      ref={ref}
      className="pointer-events-none absolute z-[9999] max-w-[90vw] w-[480px] max-h-[400px] overflow-y-auto 
      p-4 bg-white rounded-xl shadow-lg border border-blue-200 
      transition-opacity duration-200 opacity-100"
      style={{
        top: position.top - offsetTop,
        left: position.left,
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
      }}
    >
      <h4 className="font-semibold text-sm text-blue-600 mb-2">Answer</h4>
      <div className="text-sm text-gray-800 whitespace-pre-wrap break-words">
        {content}
      </div>
    </div>
  );
};

export default AnswerModal;
